import { render, staticRenderFns } from "./EnergySaving.vue?vue&type=template&id=6ed64f98&scoped=true&"
import script from "./EnergySaving.vue?vue&type=script&lang=ts&"
export * from "./EnergySaving.vue?vue&type=script&lang=ts&"
import style0 from "./EnergySaving.vue?vue&type=style&index=0&id=6ed64f98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed64f98",
  null
  
)

export default component.exports